/* eslint-disable max-lines */

import { color } from 'styles/colors'
import {
  ACCESSORIES_PLOT_BAND_Y_AXIS_NAME,
  AIRFLOW_STEPS_Y_AXIS_NAME,
  ID_PLOT_BAND_Y_AXIS_NAME,
  OD_PLOT_BAND_Y_AXIS_NAME,
  TEMP_HUMIDITY_Y_AXIS_NAME
} from 'pages/Device/ThermostatRthPanel/Chart/chartOptions'

const getStageParameter = (name, color, axis, parameterName, options = {}) => {
  const {
    min = 0,
    max = 100,
    fill = 'toself'
  } = options

  return {
    name,
    seriesName: name,
    yaxis: [...axis],
    parameterName,
    fillcolor: color,
    line: {
      color,
      shape: 'hv'
    },
    fill,
    min,
    max
  }
}

const outDoorUnit = [
  {
    name: 'outdoorLiquidPressureOccurrences',
    seriesName: 'liquidPressure',
    yaxis: AIRFLOW_STEPS_Y_AXIS_NAME,
    parameterName: 'pressure',
    line: {
      color: color('legendOdLiquidPressure'),
      shape: 'linear'
    }
  },
  {
    name: 'outdoorLiquidTempOccurrences',
    seriesName: 'odLiquidTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendOdLiquidTemp')
    }
  },
  {
    name: 'outdoorSubcoolOccurrences',
    seriesName: 'odSubcool',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendOdSubCool')
    }
  },
  {
    name: 'outdoorSuctionPressureOccurrences',
    seriesName: 'odSuctionPressure',
    yaxis: AIRFLOW_STEPS_Y_AXIS_NAME,
    parameterName: 'pressure',
    line: {
      color: color('legendOdSuctionPressure')
    }
  },
  {
    name: 'outdoorSuctionTempOccurrences',
    seriesName: 'suctionTemperature',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendOdSuctionTemperature')
    }
  },
  {
    name: 'outdoorSuperheatOccurrences',
    seriesName: 'odSuperheat',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendOdSuperheat')
    }
  },
  {
    name: 'outdoorEevStepPositionOccurrences',
    seriesName: 'odEevStepPosition',
    yaxis: AIRFLOW_STEPS_Y_AXIS_NAME,
    parameterName: 'value',
    line: {
      color: color('legendOdEevStepColor'),
      shape: 'hv'
    }
  },
  {
    name: 'outdoorCoilTemperatureOccurrences',
    seriesName: 'odCoilTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendOdCoilTemp')
    }
  },
  {
    name: 'outdoorInputCurrentOccurrences',
    seriesName: 'odCurrent',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'current',
    line: {
      color: color('legendOdCurrent')
    }
  },
  {
    name: 'outdoorGasTempOccurrences',
    seriesName: 'odGasTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendOdGasTemp')
    }
  },
  {
    name: 'outdoorGasPressureOccurrences',
    seriesName: 'odGasPressure',
    yaxis: AIRFLOW_STEPS_Y_AXIS_NAME,
    parameterName: 'pressure',
    line: {
      color: color('legendOdGasPressure')
    }
  },
  {
    name: 'outdoorTemps',
    seriesName: 'outdoorTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendOutdoor')
    }
  },
  {
    name: 'outdoorHumidity',
    seriesName: 'outdoorHumidity',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'humidity',
    line: {
      color: color('legendOutdoor'),
      dash: 'longdashdot'
    }
  }
]

const indoorUnit = [
  {
    name: 'indoorAirflowActualOccurrences',
    seriesName: 'actualAirflow',
    yaxis: AIRFLOW_STEPS_Y_AXIS_NAME,
    parameterName: 'airflow',
    line: {
      color: color('indoorUnitActualAirflow'),
      dash: 'dashdot',
      shape: 'hv'
    }
  },
  {
    name: 'indoorCoilTempOccurrences',
    seriesName: 'coilTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendIdCoilTemp'),
      dash: 'dashdot'
    }
  },
  {
    name: 'indoorGasSuperheatOccurrences',
    seriesName: 'gasSuperheat',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendIdSuperHeat'),
      dash: 'longdashdot'
    },
    connectgaps: false
  },
  {
    name: 'indoorGasSuperheatTempOccurrences',
    seriesName: 'gasSuperheat',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendIdSuperHeat'),
      dash: 'longdashdot'
    },
    connectgaps: false
  },
  {
    name: 'indoorGasTempOccurrences',
    seriesName: 'gasTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendGasTemp'),
      dash: 'longdashdot'
    }
  },
  {
    name: 'indoorEevStepPositionOccurrences',
    seriesName: 'idEevStep',
    yaxis: AIRFLOW_STEPS_Y_AXIS_NAME,
    parameterName: 'value',
    line: {
      color: color('legendIdEevStepColor'),
      shape: 'hv'
    }
  },
  {
    name: 'indoorReturnStaticPressureOccurrences',
    seriesName: 'returnStaticPressure',
    yaxis: AIRFLOW_STEPS_Y_AXIS_NAME,
    parameterName: 'pressure',
    line: {
      color: color('legendReturnStaticPressure')
    }
  },
  {
    name: 'indoorReturnAirTempOccurrences',
    seriesName: 'idReturnAirTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendIdReturnAirTempColor')
    }
  },
  {
    name: 'indoorSupplyAirTempOccurrences',
    seriesName: 'idSupplyAirTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      color: color('legendIdSupplyAirTempColor')
    }
  }
]

export const TracesConfig = [
  ...indoorUnit,
  ...outDoorUnit
]

export const AccessoriesConfig = [
  getStageParameter('VENTILATOR', color('rthVentilator'), [ACCESSORIES_PLOT_BAND_Y_AXIS_NAME], 'capacity', { min: 0, max: 50 }),
  getStageParameter('HUMIDIFIER', color('rthHumidifier'), [ACCESSORIES_PLOT_BAND_Y_AXIS_NAME], 'capacity', { min: 50, max: 100 }),
  getStageParameter('DEHUMIDIFIER', color('rthDehumidifier'), [ACCESSORIES_PLOT_BAND_Y_AXIS_NAME], 'capacity', { min: 50, max: 100 })
]

export const StageTracesConfig = [
  getStageParameter('COMPRESSOR_COOLING', color('coolStage2'), [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity', { fill: 'tozeroy' }),
  getStageParameter('COMPRESSOR_COOLING_STAGE_1', color('cool'), [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('COMPRESSOR_COOLING_STAGE_2', color('coolStage2'), [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('COMPRESSOR_HEATING', color('heatStage2'), [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity', { fill: 'tozeroy' }),
  getStageParameter('COMPRESSOR_HEATING_STAGE_1', color('heat'), [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('COMPRESSOR_HEATING_STAGE_2', color('heatStage2'), [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('DEFROST', color('rthDefrost'), [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('QUIET_MODE', color('rthQuietMode'), [OD_PLOT_BAND_Y_AXIS_NAME], 'capacity', { min: 0, max: 20 }),
  getStageParameter('SYSTEM_MODE_OFF', color('rthSystemMode'), [ID_PLOT_BAND_Y_AXIS_NAME, OD_PLOT_BAND_Y_AXIS_NAME], 'capacity', { fill: 'tozeroy' }),
  getStageParameter('INDOOR_HEATING', color('heatStage2'), [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('INDOOR_HEATING_STAGE_1', color('heatAux'), [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('INDOOR_HEATING_STAGE_2', color('heat'), [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('INDOOR_HEATING_STAGE_3', color('heatStage2'), [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('ELECTRIC_HEATING_STAGE_1', color('heatAux'), [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('ELECTRIC_HEATING_STAGE_2', color('heat'), [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('ELECTRIC_HEATING_STAGE_3', color('heatStage2'), [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('GAS_HEATING_STAGE_1', color('heatAux'), [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('GAS_HEATING_STAGE_2', color('heat'), [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('GAS_HEATING_STAGE_3', color('heatStage2'), [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('HYDRONIC_HEATING_STAGE_1', color('heat'), [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('INDOOR_FAN_ONLY', color('rthIndoorFanOnly'), [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity'),
  getStageParameter('INTEGRATED_DEHUMIDIFICATION', color('rthIntegratedDehumidification'), [ID_PLOT_BAND_Y_AXIS_NAME], 'capacity', { min: 80 }),
  ...AccessoriesConfig
]

export const ZoneTracesConfig = [
  {
    name: 'coolingSetpointOccurrences',
    seriesName: 'cooling',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      shape: 'hv',
      dash: 'dot',
      width: 1
    },
    fill: 'none'
  },
  {
    name: 'heatingSetpointOccurrences',
    seriesName: 'heating',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {
      dash: 'dash',
      shape: 'hv',
      width: 1
    },
    fill: 'none'
  },
  {
    name: 'tempOccurrences',
    seriesName: 'indoorTemp',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'temperature',
    line: {}
  },
  {
    name: 'humidityOccurrences',
    seriesName: 'indoorHumidity',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    parameterName: 'humidity',
    line: {
      dash: 'dashdot'
    }
  },
  {
    name: 'relievingOccurrences',
    seriesName: 'relieving',
    yaxis: TEMP_HUMIDITY_Y_AXIS_NAME,
    mode: 'lines+markers',
    line: {
      dash: 'solid',
      width: 8
    }
  }
]

export const Alerts = {
  name: 'alarmOccurrences'
}
